import { render, staticRenderFns } from "./GroupDealer.vue?vue&type=template&id=7098b939"
import script from "./GroupDealer.vue?vue&type=script&lang=js"
export * from "./GroupDealer.vue?vue&type=script&lang=js"
import style0 from "./GroupDealer.vue?vue&type=style&index=0&id=7098b939&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports